import { Button, Chip, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { ClientBillingInvoice } from "../../types/billing";
import { invoiceStatusColor } from "../../utils/billingFormat";
import { formatCurrency } from "../../utils/formatCurrency";

interface Props {
  invoices: ClientBillingInvoice[];
}

export default function BillingInvoicesTable({ invoices }: Props) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Number</TableCell>
          <TableCell>Subscription</TableCell>
          <TableCell>Status</TableCell>
          <TableCell align="right">Total</TableCell>
          <TableCell>Created</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {invoices.map((inv) => (
          <TableRow key={inv.id}>
            <TableCell sx={{ fontFamily: "monospace" }}>{inv.number || inv.id}</TableCell>
            <TableCell>{inv.subscription_name ?? "-"}</TableCell>
            <TableCell>
              <Chip
                label={inv.display_status}
                size="small"
                color={invoiceStatusColor(inv.display_status)}
                variant="outlined"
              />
            </TableCell>
            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
              {inv.total != null ? formatCurrency(inv.total, inv.currency) : "—"}
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>
              {dayjs(inv.created).format("MMM D, YYYY")}
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>
              {inv.hosted_invoice_url && (
                <Button
                  size="small"
                  href={inv.hosted_invoice_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ textTransform: "none", minWidth: 0, mr: 1 }}
                >
                  View
                </Button>
              )}
              {inv.invoice_pdf && (
                <Button
                  size="small"
                  href={inv.invoice_pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ textTransform: "none", minWidth: 0 }}
                >
                  PDF
                </Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
